 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT32245_COVER from '@/components/Text/32245_Cover'
 import TEXT9780062300713_COOLEY_ADCARD from '@/components/Text/9780062300713_Cooley_adcard'
 import LOVE_1 from '@/components/love_1'
 import TEXT32245_TITLEPAGE from '@/components/Text/32245_TitlePage'
 import TEXT32245_DEDICATION from '@/components/Text/32245_Dedication'
 import TEXT32245_EPIGRAPH from '@/components/Text/32245_Epigraph'
 import TEXT32245_CONTENTS from '@/components/Text/32245_Contents'
 import TEXT32245_CH01 from '@/components/Text/32245_Ch01'
 import TEXT32245_CH02 from '@/components/Text/32245_Ch02'
 import TEXT32245_CH03 from '@/components/Text/32245_Ch03'
 import TEXT32245_CH04 from '@/components/Text/32245_Ch04'
 import TEXT32245_CH05 from '@/components/Text/32245_Ch05'
 import TEXT32245_CH06 from '@/components/Text/32245_Ch06'
 import TEXT32245_CH07 from '@/components/Text/32245_Ch07'
 import TEXT32245_CH08 from '@/components/Text/32245_Ch08'
 import TEXT32245_CH09 from '@/components/Text/32245_Ch09'
 import TEXT32245_CH10 from '@/components/Text/32245_Ch10'
 import TEXT32245_CH11 from '@/components/Text/32245_Ch11'
 import TEXT32245_CH12 from '@/components/Text/32245_Ch12'
 import TEXT32245_CH13 from '@/components/Text/32245_Ch13'
 import TEXT32245_CH14 from '@/components/Text/32245_Ch14'
 import TEXT32245_CH15 from '@/components/Text/32245_Ch15'
 import TEXT32245_CH16 from '@/components/Text/32245_Ch16'
 import TEXT32245_CH17 from '@/components/Text/32245_Ch17'
 import TEXT32245_CH18 from '@/components/Text/32245_Ch18'
 import TEXT32245_CH19 from '@/components/Text/32245_Ch19'
 import TEXT32245_CH20 from '@/components/Text/32245_Ch20'
 import TEXT32245_CH21 from '@/components/Text/32245_Ch21'
 import TEXT32245_CH22 from '@/components/Text/32245_Ch22'
 import TEXT32245_CH23 from '@/components/Text/32245_Ch23'
 import TEXT32245_CH24 from '@/components/Text/32245_Ch24'
 import TEXT32245_CH25 from '@/components/Text/32245_Ch25'
 import TEXT32245_CH26 from '@/components/Text/32245_Ch26'
 import TEXT32245_CH27 from '@/components/Text/32245_Ch27'
 import TEXT32245_CH28 from '@/components/Text/32245_Ch28'
 import TEXT32245_CH29 from '@/components/Text/32245_Ch29'
 import LOVE_2 from '@/components/love_2'
 import TEXTEXCERPT1 from '@/components/Text/Excerpt1'
 import TEXTEXCERPT1A from '@/components/Text/Excerpt1a'
 import TEXT32245_ACK from '@/components/Text/32245_Ack'
 import TEXT32245_ATA from '@/components/Text/32245_ATA'
 import TEXT32245_CREDITS from '@/components/Text/32245_Credits'
 import TEXT32245_COPYRIGHT from '@/components/Text/32245_Copyright'
 import TEXT32245_ATP from '@/components/Text/32245_ATP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/32245_Contents",
 			"name" : "Text/32245_Contents",
 			"component" : TEXT32245_CONTENTS
 		},
 		{
 			"path" : "/Text/32245_Ch01",
 			"name" : "Text/32245_Ch01",
 			"component" : TEXT32245_CH01
 		},
 		{
 			"path" : "/Text/32245_Ch02",
 			"name" : "Text/32245_Ch02",
 			"component" : TEXT32245_CH02
 		},
 		{
 			"path" : "/Text/32245_Ch03",
 			"name" : "Text/32245_Ch03",
 			"component" : TEXT32245_CH03
 		},
 		{
 			"path" : "/Text/32245_Ch04",
 			"name" : "Text/32245_Ch04",
 			"component" : TEXT32245_CH04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js